function getFillClass(value: number): string {
  if (value >= 90) return 'metric-fill metric-fill-error';
  if (value >= 70) return 'metric-fill metric-fill-warn';
  return 'metric-fill metric-fill-success';
}

interface MetricBarProps {
  label: string;
  value: number;
}

export function MetricBar({ label, value }: MetricBarProps) {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div className="flex items-center gap-2">
      <span className="w-12 text-xs" style={{ color: 'var(--color-text-3)' }}>{label}</span>
      <div className="metric-track flex-1">
        <div
          className={`transition-all duration-500 ${getFillClass(clamped)}`}
          style={{ width: `${clamped}%` }}
          role="progressbar"
          aria-valuenow={clamped}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`${label} ${Math.round(clamped)}%`}
        />
      </div>
      <span className="w-10 text-right text-xs font-medium" style={{ color: 'var(--color-text-2)' }}>
        {Math.round(clamped)}%
      </span>
    </div>
  );
}
